import { sendSingular } from '../utils/singularUtils';

/**
 * @export
 * @class Tracker
 */
export default class Tracker {
  bMoving = false;

  constructor() {
    this.init();
  }

  init() {
    this.nIntervalRate = 50; // 몇 ms 에 한번식 로깅할 건지
    this.nIntervalRateOnTouch = 50; // 몇 ms 에 한번씩 로깅할 건지 (터치 디바이스)
    this.nMaxLog = 300; // 최대 몇 건의 로그를 전송할 건지 (너무 크면 서버 부하가 심할 수 있음)
    this.nMaxLogSplitter = 600; // 최대 몇 건의 최대 로그를 local 에 저장할 건지 (너무 작으면 split 이 빈번하게 발생하여 단말 부하가 심할 수 있고, 너무 크면 local 메모리 릭이 발생할 수 있음)
    this.nLogCount = 0;
    this.nScrollTop = 0;
    this.nPageX = 0;
    this.nPageY = 0;
    this.htLog = {
      agent: navigator.userAgent,
      mouse: false,
      touch: false,
      documentWidth: $(document).width(),
      windowHeight: $(window).height(),
      contentWidth: 1100,
      log: [],
    };
    this.bPlayMode = false;
    this.bMouseDebouncing = false;
    this.bTouchDebouncing = false;
    this.bTouchMoving = false;
    // $('body').append('<button type="button" id="trackerPlayModeButton" style="z-index:999999;position:fixed;bottom:60px;left:10px;width:100px;height:60px;padding:15px;background:silver;border:1px solid #000;overflow-x:hidden;overflow-y:scroll;">PLAY MODE<br>(테스트용)</div>');
    this.setLogEvent();
  }

  update(sStorageKey) {
    if (sStorageKey === 'sendTracker') {
      this.sendLog();
    }
  }

  clearEvent() {
    this.clearLogEvent();
  }

  setLogEvent() {
    if (TMON.oApp.oUtil.isTouchDevice()) {
      this.oFrameInterval = setInterval(() => {
        this.setDebouncedTouchMove();
      }, this.nIntervalRateOnTouch);
      // 터치 이벤트
      $('body').on('touchstart touchend touchmove', e => {
        this.onTouchMove(e);
      });
      // 스크롤 이벤트
      $(window).on('scroll', () => {
        this.onTouchScroll();
      });
    } else {
      // 마우스 클릭 이벤트
      $(document).on('mousemove', e => {
        this.onMouseMove(e);
      });
      $(document).on('click', e => {
        this.onMouseClick(e);
      });
      $(window).on('scroll', e => {
        this.onMouseMove(e);
      });
    }

    // 더미 이벤트 (테스트용)
    $(document).on('click', '#trackerPlayModeButton', () => {
      this.onPlayMode();
    });
  }

  clearLogEvent() {
    clearInterval(this.oFrameInterval);
    $(document).off('click', '#trackerPlayModeButton');
  }

  getPositionX(oldX) {
    const nDocumentWidth = $(document).width();
    let nGuideWidth =
      nDocumentWidth > this.htLog.contentWidth
        ? nDocumentWidth
        : this.htLog.contentWidth;
    if (TMON.bMobile) {
      nGuideWidth = nDocumentWidth;
    }
    return oldX - nGuideWidth / 2;
  }

  /**
   * onMouseMove
   * 마우스 움직임이 발생했을 때 호출
   * @param {*} e : 마우스 움직임 이벤트. 클릭 이벤트를 포함하지 않는다.
   */
  onMouseMove(e) {
    if (this.bPlayMode) {
      return;
    }
    this.htLog.mouse = true;
    this.nScrollTop = $(document).scrollTop(); // 현재 페이지의 scrollTop 값을 기록
    if (e.pageX) {
      this.nPageX = e.pageX;
    }
    if (e.pageY) {
      this.nPageY = e.pageY;
    }

    if (!this.bMouseDebouncing) {
      this.bMouseDebouncing = true;
      setTimeout(() => {
        this.setDebouncedMouseMove();
      }, this.nIntervalRate);
    }
  }

  onTouchMove(e) {
    if (this.bPlayMode) {
      return;
    }

    if (e.type === 'touchstart' || e.type === 'touchmove') {
      // console.log('start');
      this.bTouchMoving = true;
      this.nPageX = e.originalEvent.touches[0].clientX;
      this.nPageY = e.originalEvent.touches[0].clientY;
    } else {
      // console.log('end');
      this.bTouchMoving = false;
      this.nPageX = null;
      this.nPageY = null;
    }
  }

  setDebouncedTouchMove() {
    this.bTouchDebouncing = false;
    if (!this.bTouchMoving) {
      return;
    }
    this.addEventLog({
      type: 't',
      x: this.nPageX ? this.getPositionX(this.nPageX) : '',
      y: this.nPageY ? this.nPageY : '',
      scroll: $(window).scrollTop(),
    });
  }

  onTouchScroll() {
    if (this.bTouchMoving) {
      return;
    } // 터치 중일 때는 스크롤을 따로 기록하지 않는다. (터치 이벤트에서 스크롤을 기록)
    // console.log('scroll');
    if (!this.bTouchDebouncing) {
      this.bTouchDebouncing = true;
      setTimeout(() => {
        this.setDebouncedTouchMove();
      }, this.nIntervalRateOnTouch);
    }
  }

  /**
   * onMouseClick
   * 마우스 클릭 이벤트가 발생했을 때 호출
   * @param {*} e
   */
  onMouseClick(e) {
    if (
      this.bPlayMode ||
      !e.pageX ||
      e.pageX * 2 * -1 === parseInt(this.htLog.documentWidth, 10) // 모바일 디바이스의 마우스 이벤트
    ) {
      return;
    }
    this.addEventLog({
      type: 'c',
      x: this.getPositionX(this.nPageX),
      y: this.nPageY,
      scroll: $(window).scrollTop(),
    });
  }

  /**
   * setDebouncedMouseMove
   * this.nIntervalRate 를 기준으로 Debounce 된 mouseMove 이벤트를 로깅하기 위한 함수.
   * 이벤트를 매개변수로 전달하지 않는 이유는, Debounce 된 동안 실제 마우스 좌표가 변경되었을 가능성이 높기 때문이다.
   * 따라서 항상 최신 마우스 좌표를 기록하기 위해 this.nPageX , this.nPageY 를 통해 현재 좌표를 전달받는다.
   */
  setDebouncedMouseMove() {
    this.bMouseDebouncing = false;
    this.addEventLog({
      type: 'm',
      x: this.getPositionX(this.nPageX),
      y: this.nPageY,
      scroll: $(window).scrollTop(),
    });
  }

  /**
   * addEventLog
   * 공통 이벤트 로깅 함수. 마우스 움직임, 클릭, 터치 등의 모든 이벤트를 총괄하여 담당한다.
   * @param {*} htLog
   */
  addEventLog(htLog) {
    this.htLog.log.push(`${htLog.type}${htLog.x}/${htLog.y}/${htLog.scroll}`);
    this.splitLog();
  }

  splitLog() {
    this.nLogCount += 1;
    if (this.nLogCount === this.nMaxLogSplitter) {
      // console.log(this.nLogCount, this.htLog.log.length);
      this.htLog.log = this.htLog.log.slice(
        this.nMaxLogSplitter - this.nMaxLog,
        this.nMaxLogSplitter
      );
      // console.log(this.nLogCount, this.htLog.log.length);
      this.nLogCount = this.htLog.log.length;
    }
  }

  /**
   * sendLog
   * 서버에 현재 이벤트를 전송한다.
   */
  sendLog() {
    const htSendLog = this.getLog();
    htSendLog.key = TMON.oApp.htStorage.sendTracker.key;
    htSendLog.logString = window.LZString.compress(
      JSON.stringify(htSendLog.log)
    );
    TMON.oApp.oApi.fetchApi('sendTrackerApi', htSendLog);
    this.htLog.log = [];
  }

  /**
   * testLog
   * 사용방법 예시. 콘솔창에서 아래와 같이...
   * TMON.oApp.oTracker.htLog.log = JSON.parse(window.LZString.decompress('㚂₶'));
   */
  testLog = logString => {
    this.htLog.log = JSON.parse(window.LZString.decompress(logString));
    this.onPlayMode();
  };

  /**
   * fetchLog
   * 서버로부터 이벤트를 요청한다.
   */
  fetchLog() {
    const { htLog } = this;
    htLog.log = window.LZString.compress(JSON.stringify(htLog.log));
    htLog.log = JSON.parse(window.LZString.decompress(htLog.log));
    return htLog; // TODO: 향후 실제 서버로부터 이벤트를 전달받는다.
  }

  /**
   * getLog
   * 현재 로깅된 모든 이벤트를 리턴한다.
   */
  getLog() {
    return this.htLog;
  }

  /**
   * onPlayMode
   * 이벤트 플레이가 요청되었을 때 실행되는 함수
   */
  onPlayMode() {
    if (this.bPlayMode) {
      return;
    }
    this.bPlayMode = true;
    this.htPlayingLog = this.fetchLog();

    this.renderPlayer(this.htPlayingLog);
    this.setVariable();
    this.setElementCache();
    this.setPlayerEvent();
    this.clearLogEvent();
  }

  setVariable() {
    this.nNowPlayingIdx = 0;
    this.bNowPlaying = false;
  }

  renderPlayer(htPlayingLog) {
    // console.log(htPlayingLog);
    $('#trackerPlayModeButton').remove();
    $('#tracker').remove();
    const sHtml = `
            <style type="text/css">
                #tracker .inner_player .f {
                    width: ${100 / htPlayingLog.log.length}%;
                }
            </style>
            <div id="tracker">
                <div id="trackerPlayer">
                    <button type="button" data-role="play-pause">PLAY</button>
                    <div class="inner_player">
                        ${htPlayingLog.log
                          .map(
                            (item, idx) =>
                              `<div class="f"
                                    data-idx="${idx}"
                                    data-type="${item.substr(0, 1)}"
                                    data-x="${
                                      item
                                        .substr(1, item.length - 1)
                                        .split('/')[0]
                                    }"
                                    data-y="${
                                      item
                                        .substr(1, item.length - 1)
                                        .split('/')[1]
                                    }"
                                    data-scroll="${
                                      item
                                        .substr(1, item.length - 1)
                                        .split('/')[2]
                                    }"><i style="height:10%"></i></div>`
                          )
                          .join('')}
                        <div id="trackerPlayerSeeker" class="seeker"></div>
                    </div>
                </div>
                <div id="trackerStop"></div>
                <div id="trackerGuide"></div>
                <div id="trackerMousePointer"></div>
                <div id="trackerTouchPointer"></div>
            </div>
        `;
    $('body').append(sHtml);
  }

  setElementCache() {
    this.welInnerPlayer = $('#trackerPlayer .inner_player');
    this.welSeeker = $('#trackerPlayerSeeker');
    this.welFrame = $('#trackerPlayer .f');
    this.welPlayPauseButton = $('#trackerPlayer [data-role=play-pause]');
  }

  setPlayerEvent() {
    this.welInnerPlayer.on('click', '.f', e => {
      if (!e.pageX) {
        return;
      }
      const nTargetIdx = parseInt($(e.currentTarget).attr('data-idx'), 10);
      this.onSeekTo(nTargetIdx);
    });
    this.welPlayPauseButton.on('click', () => {
      this.togglePlayPause();
    });
  }

  togglePlayPause() {
    if (this.bNowPlaying) {
      this.onPause();
    } else {
      this.onPlay();
    }
  }

  renderAnimation() {
    try {
      this.welSeeker.stop();
      const sData = this.htPlayingLog.log[this.nNowPlayingIdx];
      // console.log(this.htPlayingLog.log, this.nNowPlayingIdx);
      const sType = sData.substr(0, 1);
      const aData = sData.substr(1, sData.length - 1).split('/');
      const nTargetLeft =
        $(`#trackerPlayer .f[data-idx=${this.nNowPlayingIdx}]`).offset().left -
        this.welInnerPlayer.offset().left +
        $(`#trackerPlayer .f[data-idx=${this.nNowPlayingIdx}]`).outerWidth();
      this.welSeeker.animate(
        {
          left: nTargetLeft,
        },
        this.nIntervalRate
      );

      this.nNowPlayingIdx += 1;

      let welPointer = '';
      if (sType === 't') {
        welPointer = $('#trackerTouchPointer');
      } else {
        welPointer = $('#trackerMousePointer');
      }
      welPointer.show();
      if (aData[1] && aData[1] !== null && aData[1] !== 'null') {
        welPointer.stop();
        welPointer.animate(
          { top: aData[1], marginLeft: `${aData[0]}px` },
          this.nIntervalRate
        );
      }
      if (aData[2] && aData[2] !== null && aData[2] !== 'null') {
        $('html, body').stop();
        $('html, body').animate({ scrollTop: aData[2] }, this.nIntervalRate);
      }

      if (sType === 'c') {
        $('#trackerStop').append(
          `<div class="click" style="top:${aData[1]}px;margin-left:${aData[0]}px"></div>`
        );
      }

      if (this.nNowPlayingIdx === this.htPlayingLog.log.length) {
        this.onPlayEnd();
      }
    } catch (e) {
      // console.log(e);
      this.onPlayEnd();
    }
  }

  onPlay() {
    this.bNowPlaying = true;
    this.oPlayInterval = setInterval(() => {
      this.renderAnimation();
    }, this.nIntervalRate);
  }

  /**
   * 이벤트 플레이의 일시정지
   */
  onPause() {
    this.bNowPlaying = false;
    clearInterval(this.oPlayInterval);
  }

  /**
   * 이벤트 플레이가 종료 (끝까지)
   */
  onPlayEnd() {
    // console.log('play End');
    this.bNowPlaying = false;
    this.onSeekTo(0);
    $('#trackerMousePointer').hide();
    $('#trackerTouchPointer').hide();
    clearInterval(this.oPlayInterval);
  }

  /**
   * onSeekTo
   */
  onSeekTo(nIdx) {
    let bNowPlaying = false;
    if (this.bNowPlaying) {
      bNowPlaying = true;
    }
    this.onPause();
    this.nNowPlayingIdx = nIdx;
    // console.log(`seeker to : ${nIdx}`);
    this.welSeeker.css({
      left: `${$(`#trackerPlayer .f[data-idx=${nIdx}]`).offset().left -
        this.welInnerPlayer.offset().left}px`,
    });
    if (bNowPlaying) {
      this.onPlay();
    }
  }

  dealTracking(trackingParams, eventName) {
    if (!eventName) return;

    try {
      sendSingular(trackingParams, eventName);
    } catch (error) {
      console.warn(error);
    }
  }
}
